import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';

App[$.FILENAME] = 'src/web/app.svelte';

import * as $ from 'svelte/internal/client';
import Home from "./home.svelte";
import Logo from "./logo.svelte";
import Switcher from "./switcher.svelte";
import { concepts } from "./concepts/list";

var root = $.add_locations(
	$.from_html(
		`
  <header class="absolute top-0 inset-x-0 p-5 md:p-10 flex items-center justify-center gap-3">
    <a href="/" class="flex items-center gap-3">
      <!>
      <span class="font-display text-2xl md:text-3xl font-semibold tracking-tight leading-none">CreaGeen</span>
    </a>
  </header>
  <main class="min-h-dvh flex flex-col items-center justify-center px-5 md:px-10 pt-28 pb-32">
    <!>
  </main>
  <!>
`,
		1
	),
	App[$.FILENAME],
	[[13, 2, [[14, 4, [[16, 6]]]]], [19, 2]]
);

var root_1 = $.add_locations(
	$.from_html(
		`
  <!>
`,
		1
	),
	App[$.FILENAME],
	[]
);

var root_2 = $.add_locations(
	$.from_html(
		`

<!>`,
		1
	),
	App[$.FILENAME],
	[]
);

function App($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, false, App);

	const match = location.pathname.match(/^\/(\d+)$/);
	const index = match ? Number(match[1]) - 1 : -1;
	const concept = concepts[index];
	var $$exports = { ...$.legacy_api() };

	$.init();
	$.next();

	var fragment = root_2();
	var node = $.sibling($.first_child(fragment));

	{
		var consequent = ($$anchor) => {
			var fragment_1 = root();
			var header = $.sibling($.first_child(fragment_1));
			var a = $.sibling($.child(header));
			var node_1 = $.sibling($.child(a));

			$.add_svelte_meta(() => Logo(node_1, { class: 'size-10 md:size-12' }), 'component', App, 15, 6, { componentTag: 'Logo' });
			$.next(3);
			$.reset(a);
			$.next();
			$.reset(header);

			var main = $.sibling(header, 2);
			var node_2 = $.sibling($.child(main));

			$.add_svelte_meta(() => concept.component(node_2, {}), 'component', App, 20, 4, { componentTag: 'concept.component' });
			$.next();
			$.reset(main);

			var node_3 = $.sibling(main, 2);

			{
				let $0 = $.derived_safe_equal(() => concepts.map((c) => c.title));

				$.add_svelte_meta(
					() => Switcher(node_3, {
						get current() {
							return index;
						},

						get titles() {
							return $.get($0);
						}
					}),
					'component',
					App,
					22,
					2,
					{ componentTag: 'Switcher' }
				);
			}

			$.next();
			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			var fragment_2 = root_1();
			var node_4 = $.sibling($.first_child(fragment_2));

			$.add_svelte_meta(() => Home(node_4, {}), 'component', App, 24, 2, { componentTag: 'Home' });
			$.next();
			$.append($$anchor, fragment_2);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (concept) $$render(consequent); else $$render(alternate, -1);
			}),
			'if',
			App,
			12,
			0
		);
	}

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	App = $.hmr(App);

	import.meta.hot.accept((module) => {
		App[$.HMR].update(module.default);
	});
}

export default App;